'use client'

import { useEffect } from 'react'

import AOS from 'aos'
import 'aos/dist/aos.css'

import '../../css/style.css'

import Header from '@/components/ui/header'
import Footer from '@/components/ui/footer'

import Hero from '@/components/hero'
import Clients from '@/components/clients'
import Features from '@/components/features'
import TestimonialsCarousel from '@/components/testimonials-carousel'
import Testimonials from '@/components/testimonials'

import Illustration from '@/public/images/glow-top.svg'
import Image from 'next/image'
import { useLocale } from 'next-intl'

export default function Home() {


  useEffect(() => {
    AOS.init({
      once: true,
      disable: 'phone',
      duration: 1000,
      easing: 'ease-out-cubic',
    })
  })

  const local = useLocale()


  return (
    <>
      <Header />

      <div className={`font-inter antialiased bg-slate-900 text-slate-100 tracking-tight sticky`}>
        <div className="flex flex-col min-h-screen overflow-hidden supports-[overflow:clip]:overflow-clip">
          <main className="grow">

            <main className="grow">
              <section className="relative">
                <div
                  aria-hidden="true"
                  className="absolute inset-0 overflow-hidden pointer-events-none -z-10"
                >
                  <div className="absolute flex items-center justify-center top-0 -translate-y-1/2 left-1/2 -translate-x-1/2 w-1/3 aspect-square">
                    <div className="absolute inset-0 translate-z-0 bg-purple-500 rounded-full blur-[120px] opacity-50" />
                  </div>
                </div>
                <div className="max-w-6xl mx-auto px-4 sm:px-6">
                  {local == "fr" ? FR_TERM() : EN_TERM()}
                </div>
              </section>
            </main>
          </main>

          <style
            dangerouslySetInnerHTML={{
              __html: 'h2 {    font-weight: bold !important;} h3 {    font-weight: bold !important;}'
            }}
          />
        </div>
      </div>
      <Footer />
    </>
  )
}

const FR_TERM = () => {
  return (
    <div className="py-12 md:py-20" id="tarif">
      <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
        <div>
          <div className="inline-flex font-medium bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-purple-200 pb-3" style={{ marginTop: '40px' }}>Vexub</div></div>
        <h1 className="h2 bg-clip-text text-transparent bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 pb-4">Conditions d'utilisation et de vente</h1>
      </div>
      <div>
        <div className='mb-4'> <h2>Informations sur notre société</h2> <br/> <p>Vexub est une société française enregistrée sous le numéro SIREN <strong>980 146 419</strong>. Nous opérons en tant que SAS (Société par Actions Simplifiée) et notre siège est basé à Paris.</p> <br/> <ul> <li><strong>Nom de la société :</strong> Vexub</li> <li><strong>Numéro SIREN :</strong> 980 146 419</li> <li><strong>Adresse :</strong> 9 rue jobbé duval, 75015, Paris</li> <li><strong>Lien officiel :</strong> <a href="https://annuaire-entreprises.data.gouv.fr/entreprise/vexub-980146419" target="_blank">https://annuaire-entreprises.data.gouv.fr/entreprise/vexub-980146419</a></li> </ul> <br/> <p>Nous nous engageons à la transparence et à fournir à nos utilisateurs toutes les informations nécessaires pour assurer leur confiance dans nos services. Pour toute question ou demande supplémentaire, n'hésitez pas à nous contacter à l'adresse email mentionnée ci-dessus.</p> </div>
        <h2>
          Informations sur notre société
        </h2>
        <p>
          Vexub est une société française enregistrée sous le numéro SIREN 980 146 419. Nous opérons en tant que SAS (Société par Actions Simplifiée) et notre siège est basé à Paris.


          Nom de la société : Vexub
          Numéro SIREN : 980 146 419
          Adresse : 9 rue jobbé duval, 75015, Paris
          Lien officiel : <a href="https://annuaire-entreprises.data.gouv.fr/entreprise/vexub-980146419" className='text-primary-500'>Cliquez ici</a>

          Nous nous engageons à la transparence et à fournir à nos utilisateurs toutes les informations nécessaires pour assurer leur confiance dans nos services. Pour toute question ou demande supplémentaire, n'hésitez pas à nous contacter à l'adresse email mentionnée ci-dessus.

        </p>
        <h2>
          1. Introduction
        </h2>
        <p>
          Bienvenue sur Vexub, un service en ligne proposé par Vexub, une entreprise enregistrée à Paris ! En utilisant notre service, vous acceptez les présentes Conditions d'utilisation et de vente.
        </p>
        <br />
        <br />
        <p>
          Veuillez lire attentivement ces Conditions, car elles régissent votre utilisation de notre site web situé à vexub.fr et de notre service SaaS destiné à la création de vidéos assistée par intelligence artificielle.
        </p>
        <br />
        <br />
        <h2>
          2. Abonnements
        </h2>
        <h3>
          2.1. Abonnements
        </h3>
        <p>
          Vexub propose des abonnements pour accéder à ses fonctionnalités de création de vidéos assistée par intelligence artificielle. Les détails spécifiques de chaque abonnement, y compris les prix et la durée, sont disponibles sur notre Site.
        </p>
        <br />
        <h3>
          2.2. Paiements
        </h3>
        <p>
          Lorsque vous souscrivez à un abonnement, vous devez fournir des informations de paiement, telles que le numéro de votre carte de crédit, la date d'expiration de votre carte de crédit, votre adresse de facturation et vos informations d'expédition. En fournissant ces informations, vous confirmez avoir le droit légal d'utiliser la ou les cartes de crédit ou d'autres méthodes de paiement que vous utilisez.
        </p>
        <br />
        <h3>
          2.3. Renouvellement automatique
        </h3>
        <p>
          Les abonnements Vexub sont facturés périodiquement selon une période de facturation définie, soit mensuelle, soit annuelle, en fonction du plan d'abonnement que vous choisissez lors de votre achat. À la fin de chaque période de facturation, votre abonnement sera automatiquement renouvelé aux mêmes conditions, sauf si vous décidez de l'annuler.
        </p>
        <br />
        <h3>
          2.4. Annulation
        </h3>
        <p>
          Vous pouvez annuler votre abonnement à tout moment en accédant à la gestion de votre compte en ligne ou en contactant notre service client. Une fois annulé, votre abonnement prendra fin à la fin de la période de facturation en cours, et aucun remboursement ne sera accordé pour la période restante.
        </p>
        <br />
        <br />
        <h2>
          3. Utilisation de l'intelligence artificielle
        </h2>
        <p>
          Vexub utilise des technologies d'intelligence artificielle pour faciliter la création de vidéos. Vous acceptez que l'utilisation de ces technologies peut générer des résultats variables et que la qualité des vidéos créées dépendra des données que vous fournissez et des paramètres que vous définissez. Nous ne pouvons pas garantir des résultats spécifiques.
        </p>
        <br />
        <br />
        <h2>
          4. Politique de remboursement
        </h2>
        <p>
          Garantie remboursement de 30 jours applicable uniquement au <strong>premier achat</strong>, à condition que la demande soit faite dans les 30 jours suivant le paiement et que le compte concerné ait utilisé <strong>moins de 3 crédits au total</strong>. Au-delà de 3 crédits utilisés ou passé le délai de 30 jours, tous les achats d'abonnements mensuels et annuels sont non remboursables. Une fois votre abonnement facturé hors de ces conditions, aucun remboursement ne sera accordé, quelle que soit la raison de l'annulation.
        </p>
        <br />
        <br />
        <h2>
          5. Communications
        </h2>
        <p>
          En créant un compte sur notre service, vous acceptez de recevoir des newsletters, des informations marketing ou promotionnelles et d'autres informations que nous pouvons envoyer. Vous pouvez choisir de ne plus recevoir ces communications en suivant le lien de désabonnement ou en nous contactant à info@vexub.fr.
        </p>
        <br />
        <br />
        <h2>
          6. Propriété intellectuelle
        </h2>
        <p>
          Notre service, y compris son contenu original, ses fonctionnalités et sa technologie, reste la propriété exclusive de Vexub et de ses concédants de licence. Il est protégé par des lois sur le droit d'auteur et des lois sur les marques étrangères. Vous ne pouvez pas utiliser nos marques commerciales ou notre habillage commercial sans notre consentement écrit préalable.
        </p>
        <br />
        <br />
        <h2>
          7. Utilisation interdite
        </h2>
        <p>
          Vous vous engagez à utiliser notre service de manière légale et conforme aux présentes Conditions. Vous vous interdisez notamment de :
        </p>
        <ul>
          <li>
            (a) Enfreindre toute loi nationale ou internationale applicable.
          </li>
          <li>
            (b) Exposer les mineurs à du contenu inapproprié ou préjudiciable de quelque manière que ce soit.
          </li>
          <li>
            (c) Envoyer des messages publicitaires non sollicités (spam) ou tout autre type de sollicitation.
          </li>
          <li>
            (d) Vous faire passer pour la Société, l'un de nos employés, un autre utilisateur ou toute autre personne ou entité.
          </li>
          <li>
            (e) Enfreindre les droits d'autrui ou commettre des actes illégaux, menaçants, frauduleux ou préjudiciables.
          </li>
          <li>
            (f) Perturber le bon fonctionnement du service ou causer un préjudice à la Société ou à d'autres utilisateurs.
          </li>
          <li>
            (g) Utiliser des dispositifs ou des logiciels pour interférer avec le service.
          </li>
          <li>
            (h) Introduire des virus, des chevaux de Troie ou tout autre matériel malveillant.
          </li>
          <li>
            (i) Tenter d'accéder de manière non autorisée au service ou d'interférer avec son fonctionnement.
          </li>
        </ul>
        <br />
        <br />
        <h2>
          8. Limitation de responsabilité
        </h2>
        <p>
          Nous ne pouvons garantir la disponibilité continue et ininterrompue de notre service. Nous nous réservons le droit de suspendre ou de résilier votre accès à notre service à tout moment et pour quelque raison que ce soit, sans préavis.
        </p>
        <br />
        <br />
        <h2>
          9. Modifications des Conditions
        </h2>
        <p>
          Nous nous réservons le droit de modifier ces Conditions d'utilisation et de vente à tout moment. Les modifications entreront en vigueur dès leur publication sur notre Site. Il vous incombe de consulter régulièrement ces Conditions pour prendre connaissance des mises à jour. En continuant d'utiliser notre service après toute modification, vous acceptez les Conditions modifiées.
        </p>
        <br />
        <br />
        <h2>
          10. Loi applicable
        </h2>
        <p>
          Ces Conditions d'utilisation et de vente sont régies par les lois applicables en France. Tout litige découlant de ces Conditions sera soumis à la compétence exclusive des tribunaux de Paris.
        </p>
        <br />
        <br />
        <h2>
          11. Médiation des litiges
        </h2>
        <p>
          Conformément aux articles L.616-1 et R.616-1 du Code de la consommation, notre médiateur de la consommation est :
        </p>
        <p>
          <strong>CM2C</strong> – Centre de la Médiation de la Consommation de Conciliateurs de Justice<br />
          Adresse : 49 rue de Ponthieu, 75008 Paris<br />
          Téléphone : 01 89 47 00 14<br />
          Email : contact@cm2c.net<br />
          Site : <a href="https://www.cm2c.net" target="_blank" rel="noopener noreferrer">https://www.cm2c.net</a>
        </p>
        <p>
          En cas de litige, vous pouvez déposer votre réclamation directement sur la plateforme du médiateur. Vous pouvez également recourir à la plateforme européenne de règlement en ligne des litiges : <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.
        </p>
        <br />
        <br />
        <p>
          En utilisant notre service, vous acceptez ces Conditions d'utilisation et de vente dans leur intégralité. Si vous n'acceptez pas ces Conditions, veuillez ne pas utiliser notre service.
        </p>
        <br />
        <p>
          Pour toute question ou préoccupation concernant ces Conditions d'utilisation et de vente, veuillez nous contacter à info@vexub.fr.
        </p>
        <br />
        <p>
          Dernière mise à jour : 18/08/2026
        </p>
      </div>
    </div>
  )
}

const EN_TERM = () => {
  return (
    <div className="py-12 md:py-20" id="terms">
      <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
        <div>
          <div className="inline-flex font-medium bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-purple-200 pb-3" style={{ marginTop: '40px' }}>Vexub</div>
        </div>
        <h1 className="h2 bg-clip-text text-transparent bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 pb-4">Terms of Use and Sale</h1>
      </div>
      <div>
        <div className='mb-4'>
          <h2>Information About Our Company</h2>
          <br />
          <p>Vexub is a French company registered under the SIREN number <strong>980 146 419</strong>. We operate as a SAS (Simplified Joint-Stock Company), and our headquarters are based in Paris.</p>
          <br />
          <ul>
            <li><strong>Company Name:</strong> Vexub</li>
            <li><strong>SIREN Number:</strong> 980 146 419</li>
            <li><strong>Address:</strong> 9 rue Jobbé Duval, 75015, Paris</li>
            <li><strong>Official Link:</strong> <a href="https://annuaire-entreprises.data.gouv.fr/entreprise/vexub-980146419" className='text-primary-500' target="_blank">Click Here</a></li>
          </ul>
          <br />
          <p>We are committed to transparency and to providing our users with all the necessary information to ensure their trust in our services. For any questions or additional requests, please feel free to contact us at the email address mentioned above.</p>
        </div>
        <h2>1. Introduction</h2>
        <p>Welcome to Vexub, an online service offered by Vexub, a company registered in Paris ! By using our service, you agree to these Terms of Use and Sale.</p><br /><br />
        <p>Please read these Terms carefully as they govern your use of our website located at vexub.com and our AI-assisted video creation SaaS service.</p><br /><br />
        <h2>2. Subscriptions</h2>
        <h3>2.1. Subscriptions</h3>
        <p>Vexub offers subscriptions to access its AI-assisted video creation features. Specific details of each subscription, including prices and duration, are available on our Site.</p><br />
        <h3>2.2. Payments</h3>
        <p>When you subscribe to a plan, you must provide payment information such as your credit card number, expiration date, billing address, and shipping information. By providing this information, you confirm you have the legal right to use the credit cards or other payment methods you use.</p><br />
        <h3>2.3. Automatic Renewal</h3>
        <p>Vexub subscriptions are billed periodically based on a defined billing period, either monthly or annually, depending on the subscription plan you choose during your purchase. At the end of each billing period, your subscription will automatically renew under the same conditions unless you decide to cancel it.</p><br />
        <h3>2.4. Cancellation</h3>
        <p>You can cancel your subscription at any time by accessing your online account management or by contacting our customer service. Once canceled, your subscription will end at the end of the current billing period, and no refund will be given for the remaining period.</p><br /><br />
        <h2>3. Use of Artificial Intelligence</h2>
        <p>Vexub uses AI technologies to facilitate video creation. You agree that using these technologies can produce variable results and that the quality of the created videos will depend on the data you provide and the settings you define. We cannot guarantee specific results.</p><br /><br />
        <h2>4. Refund Policy</h2>
        <p>A 30-day money-back guarantee applies only to the <strong>first purchase</strong>, provided that the request is made within 30 days of payment and the account has used <strong>fewer than 3 credits in total</strong>. Beyond 3 credits used or past the 30-day period, all monthly and annual subscription purchases are non-refundable. Once your subscription is billed outside of these conditions, no refund will be given, regardless of the reason for cancellation.</p><br /><br />
        <h2>5. Communications</h2>
        <p>By creating an account on our service, you agree to receive newsletters, marketing or promotional information, and other information we may send. You can opt-out of receiving these communications by following the unsubscribe link or by contacting us at info@vexub.fr.</p><br /><br />
        <h2>6. Intellectual Property</h2>
        <p>Our service, including its original content, features, and technology, remains the exclusive property of Vexub and its licensors. It is protected by copyright laws and foreign trademark laws. You may not use our trademarks or trade dress without our prior written consent.</p><br /><br />
        <h2>7. Prohibited Use</h2>
        <p>You agree to use our service legally and in accordance with these Terms. You are prohibited from:</p>
        <ul>
          <li>(a) Violating any applicable national or international laws.</li>
          <li>(b) Exposing minors to inappropriate or harmful content in any way.</li>
          <li>(c) Sending unsolicited advertising messages (spam) or any other solicitation.</li>
          <li>(d) Impersonating the Company, one of our employees, another user, or any other person or entity.</li>
          <li>(e) Infringing on the rights of others or committing illegal, threatening, fraudulent, or harmful acts.</li>
          <li>(f) Disrupting the proper functioning of the service or causing harm to the Company or other users.</li>
          <li>(g) Using devices or software to interfere with the service.</li>
          <li>(h) Introducing viruses, trojans, or any other malicious material.</li>
          <li>(i) Attempting to access the service without authorization or interfering with its operation.</li>
        </ul><br /><br />
        <h2>8. Limitation of Liability</h2>
        <p>We cannot guarantee the continuous and uninterrupted availability of our service. We reserve the right to suspend or terminate your access to our service at any time and for any reason without notice.</p><br /><br />
        <h2>9. Changes to the Terms</h2>
        <p>We reserve the right to modify these Terms of Use and Sale at any time. Changes will take effect upon their publication on our Site. It is your responsibility to regularly review these Terms for updates. By continuing to use our service after any changes, you accept the modified Terms.</p><br /><br />
        <h2>10. Governing Law</h2>
        <p>These Terms of Use and Sale are governed by the applicable laws of France. Any dispute arising from these Terms will be subject to the exclusive jurisdiction of the courts of Paris.</p><br /><br />
        <h2>11. Dispute Mediation</h2>
        <p>In accordance with articles L.616-1 and R.616-1 of the French Consumer Code, our consumer mediator is:</p>
        <p><strong>CM2C</strong> – Centre de la Médiation de la Consommation de Conciliateurs de Justice<br />
        Address: 49 rue de Ponthieu, 75008 Paris, France<br />
        Phone: +33 1 89 47 00 14<br />
        Email: contact@cm2c.net<br />
        Website: <a href="https://www.cm2c.net" target="_blank" rel="noopener noreferrer">https://www.cm2c.net</a></p>
        <p>In the event of a dispute, you may submit your claim directly on the mediator's platform. You may also use the European Online Dispute Resolution platform: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.</p><br /><br />
        <p>By using our service, you agree to these Terms of Use and Sale in their entirety. If you do not agree to these Terms, please do not use our service.</p><br />
        <p>For any questions or concerns about these Terms of Use and Sale, please contact us at info@vexub.fr.</p><br />
        <p>Last updated: 18/08/2026</p>
      </div>
    </div>
  )
}